// removed by extract-text-webpack-plugin
module.exports = {"container":"_2cTP2uU67xLY7jaQfGRxEO","titleContainer":"_23BYI3tmHOA2rB-NgYDvVn","caret":"_1PdocB-Q4t_0N26JacvYeQ","collapsed":"_1F2ZjWeaJboR9ZiUgRj4GT","list":"_10vvNPMw5UUcBTlDn__x19","menuIcon":"_1xCqshWrbXaiqLaYKkPncB","menuLabel":"_3_LPMj6aVaMIvvL32Sz9gP","notViewed":"_2ngqIZar9NNy3nMnJn3cRd","homePage":"_2WeejgI7ijSpCEM0HVQZXx","homesResult":"_3xiqLKUg96Ou33wQhGiUrJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDropdown/MenuDropdown.scss
// module id = 1640
// module chunks = 0